<template>
  <div class="permissionBox">
    <div class="titleBox">
      <h4 class="title">{{ title }}</h4>
      <Input
        class="input"
        v-if="hasSearch"
        v-model="inputVal"
        @on-change="inputChange"
      />
      <Button
        v-if="hasSubmit"
        type="primary"
        size="small"
        @click="handleSubmit"
      >
        保存
      </Button>
    </div>
    <div class="body">
      <div
        v-if="this.selectAll && Array.isArray(treeData) && treeData.length > 0"
        style="border-bottom: 1px solid #e9e9e9;padding:6px 0; margin:6px 0;"
      >
        <Checkbox :value="checkAll" @click.prevent.native="handleCheckAll">
          全选
        </Checkbox>
      </div>
      <Tree
        ref="tree"
        class="demo-tree-render"
        :data="treeData"
        :show-checkbox="isSelect"
        @on-select-change="onSelectChange"
        @on-check-change="onCheckChange"
        :check-strictly="true"
      ></Tree>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';
export default {
  // 到时候可以弹框展示这个组件 给modal 弹框一个 fullscreen属性就可以实现全屏
  name: 'CustomSetPermission',
  props: {
    treeData: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    hasSearch: {
      type: Boolean,
      default: false
    },
    hasSubmit: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    selectAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVal: '',
      checkAll: false
    };
  },
  methods: {
    // 节点点击
    onSelectChange(arr, item) {
      // 如果不需要点击每一行的就直接 把 selected 制为 false 就不会选中了
      if (!item.needSelected) return (item.selected = false);
      // 因为在点击 iview tree 为选中的时候，再次点击 tree 则会取消选中，所以在取消选中的时候再次给 selected 制为 true 此时高亮就不会消失了
      if (!item.selected) return (item.selected = true);
      this.$emit('on-select-change', { selectItem: item, type: this.type });
    },
    // inputonchange事件 防抖
    inputChange: debounce(function() {
      this.$emit('on-search-change', { value: this.inputVal, type: this.type });
    }, 500),
    handleSubmit() {
      this.$emit('on-select-submit', { type: this.type });
    },
    getSelectedNodes() {
      return this.$refs.tree.getSelectedNodes();
    },
    onCheckChange(arr, item) {
      // checked 为 true 是选中，为 false 是取消选中
      const isDelete = !item.checked;
      this.$emit('on-check-change', {
        isDelete,
        changeItem: item,
        type: this.type
      });
    },
    handleCheckAll() {
      if (!this.treeData || (this.treeData && this.treeData.length == 0)) {
        return false;
      }
      this.checkAll = !this.checkAll;
      this.$emit('on-select-all', { type: this.type, checkAll: this.checkAll });
    }
  },
  watch: {
    treeData: {
      deep: true,
      handler(newVal) {
        if (this.selectAll && newVal.length > 0 && newVal.every(item => item.checked)) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
.permissionBox {
  height: 100%;
  flex: 1;
  margin: 0 5px;
  display: flex;
  flex-direction: column;
  .titleBox {
    height: 40px;
    padding: 5px 10px;
    background: #ccc;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      min-width: 60px;
    }
    .input {
      width: 150px;
    }
  }
  .body {
    flex: 1;
    padding: 0 5px;
    background: #fff;
    overflow: auto;
  }
}

.demo-tree-render /deep/ .ivu-tree-title {
  width: calc(100% - 20px);
}
</style>
